module.exports = "/fonts/FiraSans-SemiBold.ttf";